// extracted by mini-css-extract-plugin
module.exports = {"main":"DeepLinks_main__1gRBu","text":"DeepLinks_text__1Ic-o","title":"DeepLinks_title__1Mvis","info":"DeepLinks_info__bgNl5","links":"DeepLinks_links__3oWC-"};